import React, { Fragment, useState } from "react";
import FilterComponent from "../../FormFields/FilterComponent/FilterComponent";
import {
  modifyAllLanguageGenreProps,
  modifySelectedLanguageGenreProps,
} from "../../CommonFunctions/ConmmonFunctions";
import { useEffect } from "react";
import FilterConfirmation from "../../FormFields/FilterConfirmationComponent/FilterConfirmation";
export default function MessageA58(props) {
  const { text_data, code } = props.item;
  const { tag } = props;
  const [confirmedData, setConfirmedData] = useState({});
  // const selectedLanguagesProps = modifySelectedLanguageGenreProps(
  //   text_data.filter.language.selectedLanguages
  // );
  // const allLanguagesProps = modifyAllLanguageGenreProps(
  //   text_data.filter.language.listOfLanguages
  // );
  // const selectedGenresProps = modifySelectedLanguageGenreProps(
  //   text_data.filter.genre.selectedGenre
  // );
  // const allGenresProps = modifyAllLanguageGenreProps(
  //   text_data.filter.genre.listOfGenre
  // );

  const selectedLanguagesProps = text_data.filter.language.selectedLanguages;

  const allLanguagesProps = text_data.filter.language.listOfLanguages;

  const selectedGenresProps = text_data.filter.genre.selectedGenre;

  const allGenresProps = text_data.filter.genre.listOfGenre;

  const [apllied, setApplied] = useState(false);

  const handleClickHere = (code, data) => {
    console.log(code, data.filterResponse, "code,data");
    setConfirmedData(data);
    props.enableDontSend();
    localStorage.setItem("selectedLanguagesAndGenres", data);

    props.handleClick(code, data, tag);
  };
  const handleFilterApplied = (data) => {
    setApplied(data);
    props.enableDontSend();
  };
  // console.log(confirmedData,"in A58")
  return (
    <Fragment>
      {!apllied ? (
        <FilterComponent
          {...props}
          tag={tag}
          filters={text_data.filter}
          selectedLanguagesProps={selectedLanguagesProps}
          allLanguagesProps={allLanguagesProps}
          selectedGenresProps={selectedGenresProps}
          allGenresProps={allGenresProps}
          onClickSubmit={(code, data, tag) => {
            handleClickHere(code, data, tag);
            // localStorage.setItem("filterApllied",true);
          }}
          code={code}
          filterToggle={(data) => {
            handleFilterApplied(data);
          }}
          selectedHd={text_data?.filter?.hdOrSd}
        />
      ) : (
        <FilterConfirmation
          mainText1={"Selected Languages"}
          mainText1Data={
            JSON.parse(localStorage.getItem("selectedLanguagesAndGenres"))
              ?.filterResponse?.selectedLanguages
          }
          mainText2={"Selected Genres"}
          mainText2Data={
            JSON.parse(localStorage.getItem("selectedLanguagesAndGenres"))
              ?.filterResponse?.selectedGenre
          }
          from={"A58"}
        />
      )}
    </Fragment>
  );
}
